import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield, Lock, Eye, FileText } from 'lucide-react';

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-[#0a0a0a] to-gray-900 py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <Card className="bg-[#111] border-gray-800">
          <CardHeader>
            <div className="flex items-center gap-3 mb-2">
              <Shield className="h-8 w-8 text-blue-500" />
              <CardTitle className="text-3xl text-white">Datenschutzerklärung</CardTitle>
            </div>
            <p className="text-gray-400">
              Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Nachfolgend informieren wir Sie 
              ausführlich über den Umgang mit Ihren Daten.
            </p>
          </CardHeader>
          <CardContent className="space-y-8 text-gray-300">
            
            {/* 1. Verantwortlicher */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">1. Verantwortlicher</h2>
              <p className="leading-relaxed">
                Verantwortlicher für die Datenverarbeitung auf dieser Website ist:
              </p>
              <div className="mt-4 p-4 bg-gray-900/50 rounded-lg">
                <p className="font-semibold text-white">Zonik Solutions</p>
                <p>Herr Subyr Fayazi</p>
                <p>Friedrichshulder Weg 157A</p>
                <p>25469 Halstenbek</p>
                <p>Deutschland</p>
                <p className="mt-2">E-Mail: Admin@zonik-solutions.de</p>
              </div>
            </section>

            {/* 2. Erhebung und Speicherung */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">
                2. Erhebung und Speicherung personenbezogener Daten
              </h2>
              
              <h3 className="text-xl font-semibold text-white mt-6 mb-3">2.1 Beim Besuch der Website</h3>
              <p className="leading-relaxed mb-4">
                Beim Aufruf unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser 
                automatisch Informationen an den Server unserer Website gesendet. Diese Informationen werden 
                temporär in einem sogenannten Logfile gespeichert. Folgende Informationen werden dabei erfasst:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>IP-Adresse des anfragenden Rechners</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Name und URL der abgerufenen Datei</li>
                <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
                <li>Verwendeter Browser und ggf. das Betriebssystem Ihres Rechners</li>
              </ul>
              <p className="leading-relaxed mt-4">
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (Berechtigtes Interesse an der 
                Sicherstellung des reibungslosen Betriebs der Website)
              </p>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3">2.2 Bei Registrierung/Kontakt</h3>
              <p className="leading-relaxed">
                Bei der Registrierung für unsere Software oder bei Kontaktaufnahme per E-Mail erheben wir:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
                <li>Vor- und Nachname</li>
                <li>E-Mail-Adresse</li>
                <li>Unternehmensdaten (Firmenname, Adresse)</li>
                <li>Telefonnummer (optional)</li>
              </ul>
              <p className="leading-relaxed mt-4">
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) bzw. 
                Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
              </p>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3">2.3 Bei Nutzung der Software</h3>
              <p className="leading-relaxed">
                Bei Nutzung unserer Fuhrparkverwaltungs-Software verarbeiten wir:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
                <li>Fahrzeugdaten (Kennzeichen, Marke, Modell)</li>
                <li>GPS-Standortdaten (nur bei aktiviertem GPS-Tracking)</li>
                <li>Mitarbeiterdaten (Name, E-Mail, zugewiesene Fahrzeuge)</li>
                <li>Belege und Rechnungen</li>
                <li>Schadensmeldungen</li>
              </ul>
              <p className="leading-relaxed mt-4">
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)
              </p>
            </section>

            {/* 3. Weitergabe von Daten */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">3. Weitergabe von Daten</h2>
              <p className="leading-relaxed">
                Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den im Folgenden aufgeführten 
                Zwecken findet nicht statt. Wir geben Ihre persönlichen Daten nur an Dritte weiter, wenn:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-4">
                <li>Sie Ihre nach Art. 6 Abs. 1 S. 1 lit. a DSGVO ausdrückliche Einwilligung dazu erteilt haben</li>
                <li>die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. f DSGVO zur Geltendmachung, Ausübung oder 
                    Verteidigung von Rechtsansprüchen erforderlich ist</li>
                <li>für den Fall, dass für die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. c DSGVO eine gesetzliche 
                    Verpflichtung besteht</li>
              </ul>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3">3.1 Lexware-Integration</h3>
              <p className="leading-relaxed">
                Bei Nutzung der Lexware-Integration werden Belegdaten an Lexware (Haufe Group) übermittelt. 
                Dies erfolgt ausschließlich nach Ihrer ausdrücklichen Einwilligung und dient der Erfüllung 
                des Vertrags.
              </p>
            </section>

            {/* 4. Cookies */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">4. Cookies</h2>
              <p className="leading-relaxed">
                Wir setzen auf unserer Website Cookies ein. Hierbei handelt es sich um kleine Dateien, die Ihr 
                Browser automatisch erstellt und die auf Ihrem Endgerät (Laptop, Tablet, Smartphone o.ä.) 
                gespeichert werden, wenn Sie unsere Seite besuchen.
              </p>
              
              <h3 className="text-xl font-semibold text-white mt-6 mb-3">4.1 Technisch notwendige Cookies</h3>
              <p className="leading-relaxed">
                Diese Cookies sind zwingend erforderlich, um die Funktionalität der Website zu gewährleisten:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
                <li>Session-Cookies (Login-Status)</li>
                <li>Authentifizierungs-Cookies</li>
                <li>Sicherheits-Cookies</li>
              </ul>
              <p className="leading-relaxed mt-4">
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (Berechtigtes Interesse)
              </p>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3">4.2 Analytische Cookies</h3>
              <p className="leading-relaxed">
                Zur Verbesserung unserer Website setzen wir Analyse-Tools ein. Diese werden nur mit Ihrer 
                ausdrücklichen Einwilligung aktiviert (Opt-in). Sie können diese Einwilligung jederzeit 
                widerrufen.
              </p>
            </section>

            {/* 5. Speicherdauer */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">5. Speicherdauer</h2>
              <p className="leading-relaxed">
                Wir speichern personenbezogene Daten nur so lange, wie dies für die Erfüllung des jeweiligen 
                Zwecks erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-4">
                <li><strong>Vertragsdaten:</strong> Während der Vertragslaufzeit + 10 Jahre (steuerrechtliche 
                    Aufbewahrungspflicht)</li>
                <li><strong>Logfiles:</strong> Automatische Löschung nach 7 Tagen</li>
                <li><strong>Marketing-Einwilligungen:</strong> Bis zum Widerruf</li>
                <li><strong>Fahrzeug-/Schadendaten:</strong> Während der Vertragslaufzeit + 3 Jahre</li>
              </ul>
            </section>

            {/* 6. Betroffenenrechte */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">6. Ihre Rechte</h2>
              <p className="leading-relaxed mb-4">
                Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:
              </p>
              
              <div className="space-y-4">
                <div className="p-4 bg-gray-900/50 rounded-lg">
                  <h4 className="font-semibold text-white mb-2 flex items-center gap-2">
                    <Eye className="h-5 w-5 text-blue-400" />
                    Recht auf Auskunft (Art. 15 DSGVO)
                  </h4>
                  <p className="text-sm">
                    Sie können Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten verlangen.
                  </p>
                </div>

                <div className="p-4 bg-gray-900/50 rounded-lg">
                  <h4 className="font-semibold text-white mb-2 flex items-center gap-2">
                    <FileText className="h-5 w-5 text-green-400" />
                    Recht auf Berichtigung (Art. 16 DSGVO)
                  </h4>
                  <p className="text-sm">
                    Sie können die Berichtigung unrichtiger oder die Vervollständigung Ihrer Daten verlangen.
                  </p>
                </div>

                <div className="p-4 bg-gray-900/50 rounded-lg">
                  <h4 className="font-semibold text-white mb-2 flex items-center gap-2">
                    <Lock className="h-5 w-5 text-red-400" />
                    Recht auf Löschung (Art. 17 DSGVO)
                  </h4>
                  <p className="text-sm">
                    Sie können die Löschung Ihrer personenbezogenen Daten verlangen, soweit keine gesetzlichen 
                    Aufbewahrungspflichten entgegenstehen.
                  </p>
                </div>

                <div className="p-4 bg-gray-900/50 rounded-lg">
                  <h4 className="font-semibold text-white mb-2">
                    Recht auf Einschränkung (Art. 18 DSGVO)
                  </h4>
                  <p className="text-sm">
                    Sie können die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten verlangen.
                  </p>
                </div>

                <div className="p-4 bg-gray-900/50 rounded-lg">
                  <h4 className="font-semibold text-white mb-2">
                    Recht auf Datenübertragbarkeit (Art. 20 DSGVO)
                  </h4>
                  <p className="text-sm">
                    Sie können verlangen, dass wir Ihnen Ihre Daten in einem strukturierten, gängigen und 
                    maschinenlesbaren Format zur Verfügung stellen.
                  </p>
                </div>

                <div className="p-4 bg-gray-900/50 rounded-lg">
                  <h4 className="font-semibold text-white mb-2">
                    Widerspruchsrecht (Art. 21 DSGVO)
                  </h4>
                  <p className="text-sm">
                    Sie können der Verarbeitung Ihrer Daten aus Gründen, die sich aus Ihrer besonderen Situation 
                    ergeben, jederzeit widersprechen.
                  </p>
                </div>
              </div>

              <p className="leading-relaxed mt-6">
                Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: 
                <a href="mailto:Admin@zonik-solutions.de" className="text-blue-400 hover:text-blue-300 ml-2">
                  Admin@zonik-solutions.de
                </a>
              </p>
            </section>

            {/* 7. Beschwerderecht */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">7. Beschwerderecht bei Aufsichtsbehörde</h2>
              <p className="leading-relaxed">
                Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung 
                Ihrer personenbezogenen Daten durch uns zu beschweren.
              </p>
              <div className="mt-4 p-4 bg-gray-900/50 rounded-lg">
                <p className="font-semibold text-white">Zuständige Aufsichtsbehörde:</p>
                <p className="mt-2">Unabhängiges Landeszentrum für Datenschutz Schleswig-Holstein</p>
                <p>Holstenstraße 98</p>
                <p>24103 Kiel</p>
                <p className="mt-2">
                  Website: <a href="https://www.datenschutzzentrum.de" target="_blank" rel="noopener noreferrer" 
                    className="text-blue-400 hover:text-blue-300">
                    www.datenschutzzentrum.de
                  </a>
                </p>
              </div>
            </section>

            {/* 8. Datensicherheit */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">8. Datensicherheit</h2>
              <p className="leading-relaxed">
                Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) 
                in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt 
                wird. Alle Daten werden in deutschen Rechenzentren gespeichert und durch modernste 
                Sicherheitstechnologien geschützt.
              </p>
              <div className="mt-4 grid md:grid-cols-3 gap-4">
                <div className="p-4 bg-gray-900/50 rounded-lg text-center">
                  <Shield className="h-8 w-8 text-green-500 mx-auto mb-2" />
                  <p className="font-semibold text-white">SSL/TLS</p>
                  <p className="text-sm text-gray-400">Verschlüsselt</p>
                </div>
                <div className="p-4 bg-gray-900/50 rounded-lg text-center">
                  <Lock className="h-8 w-8 text-blue-500 mx-auto mb-2" />
                  <p className="font-semibold text-white">ISO 27001</p>
                  <p className="text-sm text-gray-400">Zertifiziert</p>
                </div>
                <div className="p-4 bg-gray-900/50 rounded-lg text-center">
                  <FileText className="h-8 w-8 text-purple-500 mx-auto mb-2" />
                  <p className="font-semibold text-white">DSGVO</p>
                  <p className="text-sm text-gray-400">Konform</p>
                </div>
              </div>
            </section>

            {/* 9. Änderungen */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">9. Änderungen dieser Datenschutzerklärung</h2>
              <p className="leading-relaxed">
                Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen 
                rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der 
                Datenschutzerklärung umzusetzen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
              </p>
            </section>

            <div className="pt-8 border-t border-gray-800 text-sm text-gray-500">
              <p>Stand: Dezember 2025</p>
              <p className="mt-2">
                Bei Fragen zum Datenschutz kontaktieren Sie uns unter: 
                <a href="mailto:Admin@zonik-solutions.de" className="text-blue-400 hover:text-blue-300 ml-2">
                  Admin@zonik-solutions.de
                </a>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Datenschutz;
